// Libs
import axios, { AxiosResponse } from 'axios';
import { SWRResponse } from 'swr';
// App
import { CATALOG_PRODUCTS_URL } from './product.constants';
import { ProductDetails, ProductSummary } from 'app-shared/lib/api/catalog/product';
import { AxiosHookResponse, useAxiosGetRequest } from 'app-shared/lib/api/utils/axios-request.hooks';
import useSearch, { SearchHookResponse } from 'app-shared/lib/api/utils/search-hook';
import { escapeApostrophes } from 'app-shared/lib/utils/search.utils';
import { useSWRAxiosGetRequest } from 'app-shared/lib/api/utils/swr-axios-request.hooks';
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';

/**
 * Get product by id api
 */
export const getProductById = (id: number): Promise<AxiosResponse<ProductDetails>> => {
  const url = `${API_COMMON_BASE_URL}/${CATALOG_PRODUCTS_URL}/${id}`;

  return axios.get(url);
};

/**
 * Get product by slug api
 */
export const getProductBySlug = (slug: string, shopId: number): Promise<AxiosResponse<ProductDetails>> => {
  const url = `${API_COMMON_BASE_URL}/${CATALOG_PRODUCTS_URL}?slug=${slug}&shopId=${shopId}`;

  return axios.get(url);
};

/**
 * Get product api hook
 */
export const useGetProduct = (id: number): SWRResponse<ProductDetails, Error> => {
  const urlOptional = id ? `${API_COMMON_BASE_URL}/${CATALOG_PRODUCTS_URL}/${id}` : null;

  return useSWRAxiosGetRequest(urlOptional, { revalidateOnFocus: false });
};

/**
 * Get products api hook
 */
export const useGetProducts = (): AxiosHookResponse<void, ProductSummary[]> => {
  const url = `${API_COMMON_BASE_URL}/${CATALOG_PRODUCTS_URL}/summaries`;

  return useAxiosGetRequest(url);
};

/**
 * Search products api axios fetcher
 * @param keywords the keywords for search
 */
export const searchProductsFetcher = (
  keywords: string,
  mainCategoryId?: number,
  shopCategoryId?: number
): Promise<AxiosResponse> => {
  const mainCategoryIdQueryPart = (mainCategoryId && `&mainCategoryId=${mainCategoryId}`) || '';
  const shopCategoryIdQueryPart = (shopCategoryId && `&shopCategoryId=${shopCategoryId}`) || '';
  const url = `${API_COMMON_BASE_URL}/${CATALOG_PRODUCTS_URL}/search?keywords=${escapeApostrophes(
    keywords
  )}${mainCategoryIdQueryPart}${shopCategoryIdQueryPart}`;

  return axios.get(url);
};

export const useSearchProducts = (): SearchHookResponse<ProductSummary> => {
  return useSearch(searchProductsFetcher);
};
